import script from "./SingleBlogView.vue?vue&type=script&setup=true&lang=js"
export * from "./SingleBlogView.vue?vue&type=script&setup=true&lang=js"

import "./SingleBlogView.vue?vue&type=style&index=0&id=76a2b160&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76a2b160"]])

export default __exports__